import { Vector2Like, Vector3, Vector3Like } from 'three'

export default class ObstructionUtil {
  static getRotatedPositions(positions: Vector3Like[], origin = new Vector3(0, 0, 0), rotation = 0) {
    // If the object is rotated, we need to rotate the positions as well
    const rads = (Math.PI / 180) * rotation
    const sine = Math.sin(rads)
    const cosine = Math.cos(rads)
    return positions.map(pos => {
      const xOrig = pos.x - origin.x
      const yOrig = pos.y - origin.y
      return new Vector3(xOrig * cosine - yOrig * sine + origin.x, xOrig * sine + yOrig * cosine + origin.y, pos.z)
    })
  }

  static getPositionDiffs(positions: Vector2Like[]) {
    const xMin = positions.reduce((min, position) => {
      return position.x < min ? position.x : min
    }, Infinity)
    const xMax = positions.reduce((max, position) => {
      return position.x > max ? position.x : max
    }, -Infinity)
    const yMin = positions.reduce((min, position) => {
      return position.y < min ? position.y : min
    }, Infinity)
    const yMax = positions.reduce((max, position) => {
      return position.y > max ? position.y : max
    }, -Infinity)

    const xDiff = xMax - xMin
    const yDiff = yMax - yMin

    return {
      xDiff,
      xMin,
      xMax,
      yDiff,
      yMin,
      yMax,
    }
  }
}
